module.exports = __webpack_public_path__ + "static/media/return_button_w.50b0c449.svg";